exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#000",
	"menuActiveText": "#000",
	"subMenuActiveText": "#0689e7",
	"menuBg": "#fff",
	"menuHover": "#f1f9ff",
	"subMenuBg": "#fff",
	"subMenuHover": "#f1f9ff",
	"sideBarWidth": "210px"
};